var _path, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBenefits = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66797 8.73008V4.05302C3.3035 3.72741 4.45923 3.17239 5.80254 2.69753C7.18119 2.21017 8.68597 1.83325 10.0013 1.83325C11.3166 1.83325 12.8214 2.21017 14.2001 2.69753C15.5434 3.17239 16.6991 3.72741 17.3346 4.05301L17.3346 8.73007C17.3346 11.5258 15.8959 13.8938 14.1612 15.5995C13.2986 16.4479 12.3863 17.1076 11.5962 17.5499C10.7592 18.0183 10.1956 18.1666 10.0013 18.1666C9.80692 18.1666 9.24335 18.0183 8.40638 17.5499C7.61631 17.1076 6.704 16.4479 5.84134 15.5995C4.10673 13.8938 2.66797 11.5258 2.66797 8.73008Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.168,
    y1: 5,
    x2: 10.168,
    y2: 13.3333,
    stroke: "currentColor",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.168,
    y1: 9.33325,
    x2: 5.83464,
    y2: 9.33325,
    stroke: "currentColor",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBenefits, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/benefits.4a789e46.svg";
export { ForwardRef as ReactComponent };